import React, { useEffect, useState } from "react";
import "./user.css";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import axios from "axios";
import { API_URL } from "../../utils/Url";
import { useNavigate, useSearchParams } from "react-router-dom";

export const User = () => {
  const [user, setUser] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [usersPerPage] = useState(50);

  const [searchName, setSearchName] = useState("");
  const [searchMobile, setSearchMobile] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [statusFilter, setStatusFilter] = useState("");
  const [genderFilter, setGenderFilter] = useState("");

  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();

  // 1. URL Query Params hook
  const [searchParams, setSearchParams] = useSearchParams();

  // 2. Read currentPage directly from URL Query Params (Default: 1)
  const currentPage = Number(searchParams.get("page")) || 1;

  // 3. Helper function to update URL page parameter
  const handlePageChange = (newPage) => {
    setSearchParams((prevParams) => {
      prevParams.set("page", newPage);
      return prevParams;
    });
  };

  const getuser = async () => {
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      const { data } = await axios.get(`${API_URL}/api/user/get/alluser`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data) {
        setUser(data?.data || []);
        setFilteredUsers(data?.data || []);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    getuser();
  }, []);

  // FILTER + SORT LOGIC
  useEffect(() => {
    let updated = [...user];

    if (searchName.trim() !== "") {
      updated = updated.filter((u) =>
        u.name?.toLowerCase().includes(searchName.toLowerCase()),
      );
    }

    if (searchMobile.trim() !== "") {
      updated = updated.filter((u) => u.mobile?.includes(searchMobile));
    }

    if (statusFilter !== "") {
      updated = updated.filter((u) => u.userStatus === statusFilter);
    }

    if (genderFilter !== "") {
      updated = updated.filter((u) => u.gender === genderFilter);
    }

    updated.sort((a, b) => {
      if (sortOrder === "newest") {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else {
        return new Date(a.createdAt) - new Date(b.createdAt);
      }
    });

    setFilteredUsers(updated);

    // Filter change hone par silently page 1 reset kar sakte ho tabhi jab koi Search type kare
  }, [searchName, searchMobile, statusFilter, sortOrder, user, genderFilter]);

  // Pagination Logic
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);

  const goToDetails = (id) => {
    navigate(`/user-details/${id}`);
  };

  // Status Badge Helper Function
  const renderStatusBadge = (status) => {
    const config = {
      approved: "bg-success-subtle text-success border border-success-subtle",
      pending:
        "bg-warning-subtle text-warning-reveal border border-warning-subtle",
      rejected: "bg-danger-subtle text-danger border border-danger-subtle",
    };
    const badgeClass = config[status] || "bg-secondary-subtle text-secondary";
    return (
      <span
        className={`badge px-3 py-2 rounded-pill fw-semibold text-capitalize ${badgeClass}`}
      >
        {status}
      </span>
    );
  };

  return (
    <>
      <Header />
      <Sidebar />

      <div
        className="mt-5 main-content px-3 px-md-4 py-4 "
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* PREMIUM HEADER SECTION */}
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-sm-center gap-2 mb-4 p-3 bg-white border rounded-4 shadow-sm">
          <div>
            <h2 className="fw-bold text-gray-800 mb-0 fs-3">User Management</h2>
            <p className="text-muted small mb-0">
              Manage and monitor verified matrimonial user profiles
            </p>
          </div>
          <div className="bg-light px-3 py-2 rounded-3 border">
            <span className="text-muted fw-medium me-1">Total Active:</span>
            <span className="fw-bold text-primary fs-5">
              {filteredUsers.length}
            </span>
          </div>
        </div>

        {/* HIGH-CONCURRENCY OPTIMIZED FILTERS CONTAINER */}
        <div className="card border-0 rounded-4 shadow-sm mb-4">
          <div className="card-body p-4">
            <div className="d-flex align-items-center gap-2 mb-3">
              <i className="bi bi-filter-circle-fill text-primary fs-5"></i>
              <h5 className="fw-bold mb-0 text-secondary">
                Advanced Advanced Filtering
              </h5>
            </div>

            <div className="row g-3">
              <div className="col-12 col-sm-6 col-md-4 col-xl-2.5">
                <label className="form-label small fw-semibold text-muted">
                  Search by Name
                </label>
                <div className="input-group input-group-merge">
                  <input
                    type="text"
                    className="form-control rounded-3 border-light-subtle bg-light-subtle"
                    placeholder="e.g. Rahul Sharma"
                    value={searchName}
                    onChange={(e) => setSearchName(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-xl-2.5">
                <label className="form-label small fw-semibold text-muted">
                  Search by Mobile
                </label>
                <input
                  type="text"
                  className="form-control rounded-3 border-light-subtle bg-light-subtle"
                  placeholder="e.g. 9876543210"
                  value={searchMobile}
                  onChange={(e) => setSearchMobile(e.target.value)}
                />
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                <label className="form-label small fw-semibold text-muted">
                  Sort by Date
                </label>
                <select
                  className="form-select rounded-3 border-light-subtle bg-light-subtle fw-medium"
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                >
                  <option value="newest">Newest Registered</option>
                  <option value="oldest">Oldest Registered</option>
                </select>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                <label className="form-label small fw-semibold text-muted">
                  Filter by Gender
                </label>
                <select
                  className="form-select rounded-3 border-light-subtle bg-light-subtle fw-medium"
                  value={genderFilter}
                  onChange={(e) => setGenderFilter(e.target.value)}
                >
                  <option value="">All Genders</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-12 col-sm-6 col-md-4 col-xl-2">
                <label className="form-label small fw-semibold text-muted">
                  Filter by Status
                </label>
                <select
                  className="form-select rounded-3 border-light-subtle bg-light-subtle fw-medium"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="">All Statuses</option>
                  <option value="pending">Pending</option>
                  <option value="approved">Approved</option>
                  <option value="rejected">Rejected</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* PREMIUM DATATABLE CONTROLLER */}
        <div className="card border-0 rounded-4 shadow-sm overflow-hidden">
          <div className="card-body p-0">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0 custom-admin-table">
                <thead className="bg-gray-50 border-bottom">
                  <tr>
                    <th
                      className="text-muted text-uppercase fs-7 fw-bold px-4 py-3"
                      style={{ width: "60px" }}
                    >
                      #
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                      Profile
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                      Bar ID / Doc
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                      Email Address
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                      Phone Number
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold py-3">
                      Verification Status
                    </th>
                    <th className="text-muted text-uppercase fs-7 fw-bold px-4 py-3">
                      Joined Date
                    </th>
                  </tr>
                </thead>

                <tbody className="border-0">
                  {currentUsers.length > 0 ? (
                    currentUsers.map((u, index) => (
                      <tr key={u._id} className="align-middle transition-all">
                        <td className="px-4 fw-semibold text-muted">
                          {indexOfFirstUser + index + 1}
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-3">
                            <img
                              src={
                                `${API_URL}${u?.userImages[u?.userImages.length - 1]?.picUrl}` ||
                                "https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                              }
                              className="rounded-circle border border-2 border-white shadow-sm object-cover"
                              width="44"
                              height="44"
                              alt="User avatar"
                              onError={(e) => {
                                e.target.src =
                                  "https://cdn-icons-png.flaticon.com/512/3177/3177440.png";
                              }}
                            />
                            <div>
                              <span
                                className="fw-bold text-dark text-gradient-hover d-block"
                                style={{
                                  cursor: "pointer",
                                  fontSize: "14.5px",
                                }}
                                onClick={() => goToDetails(u._id)}
                              >
                                {u.name || "N/A"}
                              </span>
                              <span className="text-muted fs-7">
                                {u.gender || "Not Specified"}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          {u?.enrollIdImg ? (
                            <div className="position-relative d-inline-block shadow-sm rounded overflow-hidden border border-light-subtle hover-zoom-container">
                              <img
                                src={u.enrollIdImg}
                                alt="Bar Document"
                                className="img-fluid object-cover"
                                style={{
                                  height: "40px",
                                  width: "60px",
                                  cursor: "zoom-in",
                                }}
                                onClick={() => goToDetails(u._id)}
                              />
                            </div>
                          ) : (
                            <span className="text-muted fs-7 italic">
                              No Document
                            </span>
                          )}
                        </td>
                        <td className="text-secondary font-monospace fs-7">
                          {u.email}
                        </td>
                        <td className="text-dark fw-medium">
                          {u.mobile || "—"}
                        </td>
                        <td>{renderStatusBadge(u.userStatus)}</td>
                        <td className="px-4 text-muted fs-7">
                          {u.createdAt
                            ? new Date(u.createdAt).toLocaleDateString(
                                "en-IN",
                                {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                },
                              )
                            : "—"}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-5">
                        <div className="text-muted flex flex-column align-items-center justify-content-center gap-2">
                          <i className="bi bi-person-x fs-1 text-gray-300"></i>
                          <p className="mb-0 fw-medium">
                            No matching user records found
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* PREMIUM PAGINATION INTERFACE */}
            {totalPages > 1 && (
              <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center gap-3 p-4 border-top bg-light-subtle">
                <div className="text-muted small">
                  Showing{" "}
                  <span className="fw-semibold text-dark">
                    {indexOfFirstUser + 1}
                  </span>{" "}
                  to{" "}
                  <span className="fw-semibold text-dark">
                    {indexOfLastUser > filteredUsers.length
                      ? filteredUsers.length
                      : indexOfLastUser}
                  </span>{" "}
                  of{" "}
                  <span className="fw-semibold text-dark">
                    {filteredUsers.length}
                  </span>{" "}
                  entries
                </div>

                <nav aria-label="User navigation adjustment">
                  <ul className="pagination pagination-sm mb-0 gap-1">
                    {/* Previous Button */}
                    <li
                      className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3"
                        onClick={() =>
                          handlePageChange(Math.max(currentPage - 1, 1))
                        }
                      >
                        Previous
                      </button>
                    </li>

                    {/* Page Numbers */}
                    {[...Array(totalPages)].map((_, i) => {
                      if (
                        totalPages > 6 &&
                        Math.abs(currentPage - (i + 1)) > 2 &&
                        i !== 0 &&
                        i !== totalPages - 1
                      ) {
                        if (i === 1 || i === totalPages - 2) {
                          return (
                            <li key={i} className="page-item disabled">
                              <span className="page-link border-0 bg-transparent">
                                ...
                              </span>
                            </li>
                          );
                        }
                        return null;
                      }

                      return (
                        <li
                          key={i}
                          className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                        >
                          <button
                            className="page-link rounded-2 border fw-semibold px-3"
                            onClick={() => handlePageChange(i + 1)}
                          >
                            {i + 1}
                          </button>
                        </li>
                      );
                    })}

                    {/* Next Button */}
                    <li
                      className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link rounded-2 border px-3"
                        onClick={() =>
                          handlePageChange(
                            Math.min(currentPage + 1, totalPages),
                          )
                        }
                      >
                        Next
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};;
